export const getProfile = (state) => state.profile;

export const getUserTenants = (state) =>
  state.userTenants.userTenants.filter((tenant) => tenant.active !== false);
